import { NoddiCircularLoader } from './NoddiCircularLoader';

export const LoadingScreen = ({ loadingText }: { loadingText?: string }) => (
  <div className='flex min-h-[60vh] justify-center'>
    <NoddiCircularLoader loadingText={loadingText} />
  </div>
);
